// src/components/AdminRoute.js
import { getToken } from "../services/auth";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function AdminRoute({ children }) {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  try {
    const decoded = jwtDecode(token);
    if (decoded?.role !== "admin") return <Navigate to="/home" replace />;
  } catch {
    return <Navigate to="/login" replace />;
  }
  return children;
}
